import CheckIcon from '@mui/icons-material/Check';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import React from 'react';

import { QCImpactId } from 'interfaces/qcMarkers';

interface ImpactIconProps {
  qcImpactId: string;
  emptyIconPlaceholder?: boolean;
  rotate?: number;
  withColor?: boolean;
}

const ImpactIcon: React.FC<ImpactIconProps> = ({ qcImpactId, emptyIconPlaceholder, rotate, withColor = true }) => {
  const sx = {
    mr: 1,
    transform: rotate ? ` rotate(${rotate}deg)` : undefined,
    display: 'flex',
    alignItems: 'center',
  };

  if (qcImpactId === QCImpactId.FLAGGED) {
    return <WarningAmberIcon color={withColor ? 'warning' : 'inherit'} fontSize="small" sx={sx} />;
  } else if (qcImpactId === QCImpactId.EXCLUDE) {
    return <HighlightOffIcon color={withColor ? 'error' : 'inherit'} fontSize="small" sx={sx} />;
  } else if (qcImpactId === QCImpactId.USABLE) {
    return <CheckIcon fontSize="small" sx={sx} />;
  }

  // return empty icon for spacing
  return emptyIconPlaceholder ? (
    <span style={{ display: 'inline-block', width: 20, height: 20, marginRight: 8 }} />
  ) : null;
};

export default ImpactIcon;
